require("@rails/ujs").start();

require("jquery");
window.$ = window.jQuery = jQuery;
import "../libraries/jquery-ui";

import I18n from "i18n-js";
window.I18n = I18n;

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

import "bootstrap";
import bootbox from "bootbox";
window.bootbox = bootbox;
import "../libraries/window_resize_helper";

$(function () {
  /**
   * Help
   */
  $(document.body).on("click", ".help-link", function (e) {
    e.preventDefault();

    bootbox.alert({
      buttons: {
        ok: {
          label: "Done",
        },
      },
      title: "Need Help?",
      message: $("#help-link-content").html(),
    });
  });

  /**
   * Modal links (for tests and assessments)
   */
  $(document.body).on("click", ".modal-link", function (e) {
    e.preventDefault();

    var $win = $(window);
    var win_height = $win.height();

    var opts = {
      className: "modal-fullscreen",
      size: "large",
      message:
        '<iframe allowfullscreen frameborder="0" height="100%" width="100%" style="margin-top:15px;height:' +
        (win_height - 180) +
        'px" src="' +
        $(e.currentTarget).attr("href") +
        '"></iframe>',
      callback: function () {
        $(window).off("resize.modal_link");
      },
    };
    if ($(e.target).hasClass("hide-modal-footer")) {
      opts.className = "modal-fullscreen hide-modal-footer";
    }

    var modal_link_modal = bootbox.alert(opts);

    modal_link_modal.init(function () {
      $(window).on("resize.modal_link", function () {
        var $win = $(window);
        var win_height = $win.height();
        $(".modal-fullscreen iframe").height(win_height - 180);
      });
    });
  });

  /*
   * iframe helpers (iframe height communication, etc)
   */
  $(document.body).on(
    "click",
    ".next .btn, .previous .btn, .btn-submit, .next-article",
    function (e) {
      if (!$(e.target).hasClass("no-scroll-to-top")) {
        window.scrollTo(0, 0);
      }
    }
  );

  $(window).on("load", function () {
    window.scrollTo(0, 0);
  });

  $(window).on("shown.bs.modal", function () {
    window.scrollTo(0, 0);
    $win.trigger("resize.broadcastDimensions");
  });

  function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight,
      newHeight;
    (function run() {
      newHeight = elm.clientHeight;
      if (lastHeight != newHeight) callback();
      lastHeight = newHeight;

      if (elm.onElementHeightChangeTimer)
        clearTimeout(elm.onElementHeightChangeTimer);

      elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  }

  /*
   * Collapsible course collection groups
   */
  $(document.body).on(
    "click",
    ".course-collection-group-name .chevron-wrapper",
    (e) => {
      var $target = $(e.target);
      if ($target.hasClass("chevron")) {
        $target = $target.parent(".chevron-wrapper");
      }
      if ($target.data("toggle") === "expanded") {
        $target
          .data("toggle", "collapsed")
          .find(".chevron")
          .removeClass("down")
          .addClass("right")
          .end()
          .parents(".course-collection-group")
          .find(".course-collections")
          .slideUp();
      } else {
        $target
          .data("toggle", "expanded")
          .find(".chevron")
          .removeClass("right")
          .addClass("down")
          .end()
          .parents(".course-collection-group")
          .find(".course-collections")
          .slideDown();
      }
    }
  );

  onElementHeightChange(document.body, function () {
    parent.postMessage("ffg-height|" + $(document.body).height(), "*");
  });

  var $win = $(window);

  $win.on("resize.broadcastDimensions", function () {
    parent.postMessage("ffg-height|" + $(document.body).height(), "*");
  });

  setTimeout(function () {
    $win.trigger("resize.broadcastDimensions");
  }, 1);

  var eventMethod = window.addEventListener
    ? "addEventListener"
    : "attachEvent";
  var eventer = window[eventMethod];
  var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

  // listen to message from child window
  eventer(
    messageEvent,
    function (e) {
      if (e && e.data && e.data.split) {
        var name = e.data.split("|")[0];
        var value = e.data.split("|")[1];
        //console.log('messageEvent', name, value);
        if (name == "ffg-height") {
          //console.log('update height');
          $("#ffg-iframe").height(value);
          //window.scrollTo(0, 0);
        }
      } else {
        //console.log('messageEvent...nodata', e);
      }
    },
    false
  );
});
